export default __webpack_public_path__ + "static/media/client14.b32e6532.jpg";